import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Eklentileri kaydet
gsap.registerPlugin(ScrollTrigger);

// Build sonrasi icerik snapshot'i (scripts/prerender.mjs pas-2) sirasinda giris
// animasyonlarini aninda bitir; aksi halde metin opacity: 0 ile yakalanir.
if (typeof window !== "undefined" && window.__PRERENDER__ === true) {
    gsap.globalTimeline.timeScale(1000);
}

export { gsap, ScrollTrigger };


